import { combineReducers } from 'redux'
//despesasPorOrgao
import resultados from './detalhesTransfFinAdm'
import filtro from './filtro'
import filtroAplicados from './filtroAplicados'

export default combineReducers({ resultados, filtro, filtroAplicados })
